import { Box, ColorOptions, Icon, Loader, Spacer, Text } from '@jfs/ui-new'
import { FC, memo } from 'react'
import { isOsMobile } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import styles from './styles'

interface EmptyVewProps {
  onRetry: () => void
  isLoading: boolean
  error?: any
  loadingMessage?: string
  emptyMessage?: string
  hide?: boolean
  testID?: string
  loaderColor?: ColorOptions
  shouldShowSwitchMerchant?: boolean
  setMidListVisible?: any
}

const EmptyView: FC<EmptyVewProps> = ({
  onRetry,
  isLoading,
  error,
  emptyMessage = '',
  hide = false,
  testID = '',
  loaderColor = 'PRIMARY',
  shouldShowSwitchMerchant = false,
  setMidListVisible,
}: EmptyVewProps) => {
  if (hide) {
    return null
  }
  const DEFAULT_ERROR = 'Something went wrong!'
  const getMessage = (): string => {
    if (error) {
      return error || DEFAULT_ERROR
    }
    if (!isLoading) {
      return emptyMessage
    }
    return ''
  }

  return (
    <Box
      testID={testID}
      justifyContent="center"
      {...styles(hide).centerAlignment}
      {...(!isOsMobile() && { flex: 1 })}
      {...(isOsMobile() && { alignSelf: 'center', height: '100%' })}>
      <Text testID={'errorText'} hide={!(getMessage().length > 0) || isLoading} {...styles(hide).titleEmpty}>
        {getMessage()}
      </Text>
      <Spacer direction="vertical" size={20} />
      {error && !isLoading && (
        <>
          <ModBox testID={'retry'} onPress={onRetry} show={error && !isLoading} underlayColor="TRANSPARENT">
            <Icon id="ICON_REFRESH" size={28} color={loaderColor} />
          </ModBox>
          {shouldShowSwitchMerchant && (
            <>
              <Spacer size={8} />
              <Box onPress={() => setMidListVisible(true)}>
                <Text color={'PRIMARY'} fontFamily="JioType-Medium">
                  Switch merchant
                </Text>
              </Box>
            </>
          )}
        </>
      )}
      {isLoading && <Loader testID={'loader'} color={loaderColor} />}
    </Box>
  )
}

export default memo(EmptyView)
